import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { ProductId} from "@@/shared/products/product-id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type ShortLinkGenerateCommand = {
    readonly _id: string;
    readonly _type: "SHORT_LINK_GENERATE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly for: "PRODUCT";
    readonly forId: ProductId;
};

type CreateParams = Except<
    ShortLinkGenerateCommand,
    "_id" | "_type" | "_createdAt"
>;
const createShortLinkGenerateCommand = (params: CreateParams) => {
    const shortLinkGenerateCommand: ShortLinkGenerateCommand = {
        ...params,
        _id: generateId({ prefix: "short_link_generate_command__" }),
        _type: "SHORT_LINK_GENERATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return shortLinkGenerateCommand;
};

const shortLinkGenerateCommandZodSchema: z.ZodSchema<ShortLinkGenerateCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("SHORT_LINK_GENERATE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        for: z.enum(["PRODUCT"]),
        forId: productIdZodSchema,
    });

export { createShortLinkGenerateCommand, shortLinkGenerateCommandZodSchema };
export type {
    CreateParams as CreateShortLinkGenerateCommandParams,
    ShortLinkGenerateCommand,
};
